export const GameHeaderConst = {
  headers: [
    { property: "name", numeric: false, label: "Game" },
    { property: "", numeric: false, label: "", disableSort: true },
    { property: "rank.overall", numeric: true, label: "BGGRank", ignoredValues: [0] },
    { property: "rating.average", numeric: true, label: "Rating" },
    { property: "weight.average", numeric: true, label: "Difficulty", ignoredValues: [0] },
    { property: "playTime.min", numeric: true, label: "Playtime (Min)" },
    { property: "playTime.max", numeric: true, label: "Playtime (Max)",
      ignoredValues: [0] },
    { property: "players.age.min", numeric: true, label: "Age (Min)",
      ignoredValues: [0] },
    {
      property: "players.age.recommended",
      numeric: true,
      label: "Age (Recommended)",
      ignoredValues: ["(no votes)"]
    },
    {
      property: "categories",
      numeric: false,
      label: "Categories",
      disableSort: true,
    },
    {
      property: "mechanics",
      numeric: false,
      label: "Mechanics",
      disableSort: true,
    },
    { property: "yearPublished", numeric: true, label: "Year",
      ignoredValues: [0] },
  ],
};
